$(document).on('click', '.sphere-of-education__text', function () {
    let btnBackOne = $('.sphere-of-education__back._one');
    let btnBackSec = $('.sphere-of-education__back._sec');

    if (window.matchMedia('(min-width: 1024px)').matches) {

        if ($(this).parent().hasClass('_one')) {

            let itemTabName = $(this).attr('data-target');
            let secBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._sec');
            let thirdBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._third');

            $(this).addClass('_visible-icon');
            $(this).siblings().removeClass('_visible-icon');
            secBlock.find(`.${itemTabName}`).addClass('_active');
            secBlock.find(`.${itemTabName}`).siblings().removeClass('_active');

            if (thirdBlock.children().hasClass('_active')) {
                thirdBlock.find('._active').removeClass('_active');
            };

        } else if ($(this).parents().hasClass('_sec')) {

            let itemTabName = $(this).attr('data-target');
            let thirdBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._third');

            $(this).addClass('_visible-icon');
            $(this).siblings().removeClass('_visible-icon');
            thirdBlock.find(`.${itemTabName}`).addClass('_active');
            thirdBlock.find(`.${itemTabName}`).siblings().removeClass('_active');
        }
    }
    else if (window.matchMedia('(max-width: 1023px)').matches) {

        if ($(this).parent().hasClass('_one')) {

            let itemTabName = $(this).attr('data-target');
            let secBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._sec');

            $(this).addClass('_visible-icon');
            $(this).siblings().hide();
            secBlock.find(`.${itemTabName}`).addClass('_active');
            btnBackOne.addClass('_visible').show();


            btnBackOne.on('click', function () {
                $('._visible-icon').siblings().show();
                $('._visible-icon').removeClass('_visible-icon');
                secBlock.find('._active').removeClass('_active');
                btnBackOne.hide();
            })

        } else if ($(this).parents().hasClass('_sec')) {

            let itemTabName = $(this).attr('data-target');
            let thirdBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._third');
            let firstBlock = $(this).parents('.sphere-of-education').find('.sphere-of-education__block._one');
            let secBlock = $('.sphere-of-education__block._sec');

            btnBackOne.hide();
            btnBackSec.addClass('_visible').show();

            $(this).addClass('_visible-icon');
            $(this).siblings().hide();

            thirdBlock.find(`.${itemTabName}`).addClass('_active');
            firstBlock.find('.sphere-of-education__text').hide();


            btnBackSec.on('click', function () {

                btnBackSec.hide();
                btnBackOne.show();

                thirdBlock.find('._active').removeClass('_active');
                secBlock.find('._active').children().show();
                secBlock.find('._visible-icon').removeClass('_visible-icon');
                firstBlock.find('._visible-icon').show();
            })
        }
    }
})





$(document).on('click', '.sphere-of-education__link', function (e) {
    e.preventDefault();

    let thisElemText = $(this).find('.sphere-of-education__text').text();
    let thisElemId = $(this).attr('data-target');
    let popupInput = $('.input-list__popup-input');
    let sferaObrInput = popupInput.find('input[type=text]');
    let hiddenInput = popupInput.find('.js-programm-hidden-input');
    let inputSvgIcon = popupInput.find('.input-list__three-dots');

    sferaObrInput.val(thisElemText);
    // sferaObrInput.attr("placeholder", `${thisElemText}`);
    hiddenInput.val(thisElemId);

    inputSvgIcon.hide();
    $('.popup_sfera').magnificPopup('close');
})